module.exports = __webpack_public_path__ + "static/media/workPvcCeilings5.88e31d49.jpg";